import _Vue from 'vue';
export default function eventBusPlugin(Vue) {
  Vue.prototype.$bus = new _Vue();
}